import { useMemo } from "react";
import { detectDataType, DataType } from "./detect";

/**
 * Scan the first `sampleSize` rows and infer a single DataType for every column.
 * Returns a stable object reference unless data/columns change.
 */
export function useColumnTypes(
  data: Record<string, unknown>[],
  columns: string[],
  sampleSize: number = 50,
): Record<string, DataType> {
  return useMemo(() => {
    const counts: Record<string, Record<DataType, number>> = {};
    columns.forEach((c) => {
      counts[c] = { number: 0, date: 0, boolean: 0, string: 0 };
    });

    data.slice(0, sampleSize).forEach((row) => {
      columns.forEach((c) => {
        const t = detectDataType(row[c]);
        counts[c][t] += 1;
      });
    });

    const result: Record<string, DataType> = {};
    columns.forEach((c) => {
      const tally = counts[c];
      let best: DataType = "string";
      let bestCount = -1;
      (Object.keys(tally) as DataType[]).forEach((k) => {
        if (tally[k] > bestCount) {
          best = k;
          bestCount = tally[k];
        }
      });
      result[c] = best;
    });

    return result;
  }, [data, columns, sampleSize]);
}
